// extracted by mini-css-extract-plugin
export var actionButtons = "_52-0";
export var image = "_52-7";
export var product = "_52-1";
export var productContainer = "_52-3";
export var productLeft = "_52-5";
export var productRight = "_52-6";
export var resultsContainer = "_52-2";
export var searchInput = "_52-8";
export var variantContainer = "_52-4";